<template>
  <div class="outer-box" >
    <h4>Disable ISV for Location</h4>

    <div class="inner-box" style="text-align: left; width: 500px;">
      <b-alert show variant="danger">
        <b>Before disabling ISV, please notify the agency owner:</b>
        <br/>
        1. All phone numbers currently in this location will be released
        <br/>
        2. <b>This step is irreversible</b>
      </b-alert>
      <div>Location ID</div>
      <input
        class="hl_input--wrap "
        type="text"
        placeholder="Location ID"
        v-model="locationId"
      />
      <br />
      <br />
      <div>Twilio Account SID</div>
      <input
        class="hl_input--wrap "
        type="text"
        placeholder="Account SID"
        v-model="accountSID"
      />
      <br />
      <br />
      <div>Twilio Account Token</div>
      <input
        class="hl_input--wrap "
        type="text"
        placeholder="Token"
        v-model="token"
      />
      <!--TODO Need the AccountSID and Auth Token field -->
      <button :disabled="disabled || processing" class="btn btn-danger mt-4" @click="disableISVForLocation">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Disable ISV </span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from '@/services';

export default {
  data() {
    return {
      locationId: '',
      accountSID: '',
      token: '',
      processing: false,
      response: null
    };
  },
  computed: {
    disabled() {
      if (this.locationId.length <= 0 || this.accountSID <= 0 || this.token <= 0) return true
      else return false
    }
  },
  methods: {
    disableISVForLocation(){
      this.processing = true
      SaasService.disableIsvMode(this.locationId, {
          accountSID: this.accountSID,
          token: this.token
        })
        .then(response => {
          this.response = response.data
        })
        .catch(error => {
          this.response = error.response.data
        })
        .finally(() => {
          this.processing = false;
        });
    },
  }
}
</script>

<style>
</style>
